import * as React from 'react';
import {MenuItem, InputLabel, FormControl} from '@mui/material';
// import  from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useWindowDimensions from '../WindowDimention/windowDimention';

export default function SelectLabels({title,setReasonToRemove,reasonToRemove}) {
  const { height, width } = useWindowDimensions();
  return (
    <div>
      <FormControl sx={{ m: 0 }} variant="outlined">
        <InputLabel 
          id="demo-simple-select-autowidth-label"
          sx={{
            "&.MuiOutlinedInput-notchedOutline": {
              borderColor: "#e5e7eb"
            },
            "&.Mui-focused": {
              color: "#1976d2"
            }
          }}
        >
          {title || "Reason"}
        </InputLabel>
        <Select
          sx={{
            width: width > 480 ? "300px" : "180px", 
            "& .MuiOutlinedInput-root": { 
              borderRadius: "10px", 
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)", 
              "& fieldset": { 
                borderColor: "#d1d5db",
                borderWidth: "1px"
              },
              "&:hover fieldset": {
                borderColor: "#9ca3af"
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
                borderWidth: "2px"
              }
            } 
          }}
          value={reasonToRemove?.reason || ""}
          onChange={(e) =>
            setReasonToRemove({ ...reasonToRemove, reason: e.target.value })
          }
          labelId="demo-simple-select-autowidth-label"
          label={title || "Reason"}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          renderValue={(selected) => {
            if (!selected) return "";
            else return selected;
          }}
        >
          <MenuItem value="" disabled>
            <em>Select a reason...</em>
          </MenuItem>
          <MenuItem value={"In-house professionals assigned"}>
            In-house professionals assigned
          </MenuItem>
          <MenuItem value={"Professional found untrained"}>
            Professional found untrained
          </MenuItem>
          <MenuItem value={"Shift postponed"}>Shift postponed</MenuItem>
          <MenuItem value={"Posted by mistake"}>Posted by mistake</MenuItem>
          <MenuItem value={"Others"}>Others</MenuItem>
          {/* <MenuItem value={"Own Staff Turned Back on Duty"}>Own Staff Turned Back on Duty</MenuItem>
          <MenuItem value={"Staff came for duty is not trained"}>Staff came for duty is not trained</MenuItem>
          <MenuItem value={"Staff came for duty is not up to the expectation"}>Staff came for duty is not up to the expectation</MenuItem>
          <MenuItem value={"Service postponed for which job was posted"}>Service postponed for which job was posted</MenuItem>
          <MenuItem value={"Job posted by mistake"}>Job posted by mistake</MenuItem> */}
        </Select>
      </FormControl>
    </div>
  );
}
